import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-spinedit',
  templateUrl: './spinedit.component.html',
  styleUrls: ['./spinedit.component.scss']
})
export class SpinEditComponent implements OnInit {
 
  public step = 1;
  private valueReplaced: string;
  @Input() public min: number = 0;
  @Input() public max: number = 99999;
  @Input() public decimal = false;
  @Input() public isReadOnly =  false;

  @Output() valueNumberChange: EventEmitter<number> = new EventEmitter<number>();
  @Output() isValidChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  private _isValid : boolean;
  public get isValid() : boolean {
    return this._isValid;
  }
  @Input() public set isValid(valid: boolean) {
    this._isValid = valid;
    this.isValidChange.emit(valid);
  }


  private currentValueNumber: number;
  @Input() set valueNumber(valueToSet: number) {    
    if(this.currentValueNumber !== valueToSet) {
      this.currentValueNumber = valueToSet ? valueToSet : 0;
      this.setDisabledButtons();
      this.checkIsValid();
    }
    this.invert = valueToSet < 0;
    this.updateValueStr(valueToSet);
    this.valueNumberChange.emit(this.currentValueNumber);
  }
  get valueNumber(): number {
      return this.currentValueNumber; 
  }
  
 
  private _value : string;
  public get valueStr() : string {
    return this._value;
  }

  public set valueStr(valueToSet : string) {    
    this.valueReplaced = valueToSet.replace(',','.');
    this._value =  this.updateValueEtered(this.valueReplaced);
  }

  private isDecrementDisabled =  false;
  private isIncrementDisabled =  false;

  oldValue: string;
  invert: boolean;
  constructor() {
  }

  ngOnInit() {
    this.invert = this.currentValueNumber < 0;
    this.updateValueStr(this.valueNumber);
    this.oldValue = this.valueStr;
    this.setDisabledButtons();
  }

  updateValueStr(valueToset: number) {
    let valueUpdate = '';
    if(this.decimal){
      valueUpdate = valueToset.toString();
    } else {
      valueUpdate = valueToset.toFixed(0);
    }

    if(valueUpdate !== this.valueStr){
      this.valueStr = valueUpdate;
    }
  }

  updateValueEtered(valueStr: string): string {
    let parsed = parseFloat(valueStr);
    if(isNaN(parsed)){
      parsed =  parseFloat(this.oldValue);
      valueStr = this.oldValue;
    }
    if(this.invert){
      if(parsed > 0){
        parsed = parsed * -1;
      }
    }else {
      if(parsed < 0 ){
        parsed = parsed * -1;
      }
    }
    if(this.decimal){
      valueStr = parsed.toString();
    } else {
      valueStr = parsed.toFixed(0);
    }
    if(parsed !== this.valueNumber) {
      this.valueNumber =  parsed;
    }
    return valueStr;
  }

  onKeyDown(event: KeyboardEvent ) {
    if((event.keyCode >= 64  && event.keyCode <= 91) ||
       (event.keyCode >= 218 && event.keyCode <= 223) ||       
       (event.keyCode === 187) || //=
       (event.keyCode === 111) || // num/
       (event.keyCode === 106) || // num*
       (event.keyCode === 107) || // num+ 
       (event.shiftKey === true) || // with shift
       (event.keyCode > 190 && event.keyCode <= 193))
    {
      event.preventDefault();
    }

    if(!this.decimal &&
      ((event.keyCode === 188) || // ,
      (event.keyCode === 190) || // .
      (event.keyCode === 110)  // num ,
      )){
      event.preventDefault();
    }
    if(this.decimal &&
      this.valueReplaced.includes('.') &&
      ((event.keyCode === 188) || // ,
      (event.keyCode === 190) || // .
      (event.keyCode === 110)  // num ,
      )){
      event.preventDefault();
    }

    this.oldValue =  this.valueStr;
    if(event.keyCode === 109 || event.keyCode === 189) {
      event.preventDefault();
      this.invert = !this.invert;
      this.valueStr = this.valueStr;
    }

  }

  setDisabledButtons() {    
    if(this.valueNumber >= this.max){
      this.isIncrementDisabled = true;
    }else{
      this.isIncrementDisabled = false;
    }
    if(this.valueNumber <= this.min){
      this.isDecrementDisabled = true;
    }else{
      this.isDecrementDisabled = false;
    }
  }

  public decrement() {
    if(this.valueStr.length == 0) {this.valueStr ='0'};

    let decrement = this.valueNumber - this.step;
    if(decrement <= this.min){
      decrement = this.min;
    }
    this.oldValue = this._value;
    this.invert =  decrement < 0;    
    var str = this.valueStr.substr(this.valueStr.indexOf('.'));
    decrement = parseFloat(decrement.toFixed(str.length));
    this.valueNumber = decrement;
    this.updateValueStr(this.valueNumber);
  }

  public increment() {
    if(this.valueStr.length == 0) { this.valueStr ='0'};
    let increment = this.valueNumber;
    increment += this.step;    
    if(increment >= this.max){
      increment = this.max;
    }    
    this.oldValue = this._value;
    var str = this.valueStr.substr(this.valueStr.indexOf('.'));
    increment = parseFloat(increment.toFixed(str.length));
    this.invert =  increment < 0;
    this.valueNumber = increment;
    this.updateValueStr(this.valueNumber);
  }

 
  private checkIsValid() {    
    if(this.valueNumber <= this.max && this.valueNumber >= this.min ){
      this.isValid = true;
    } else{
      this.isValid = false;
    }
  }  

  // setStrignValue(val: number){
  //   const res = this.valueStr.split('.');
  //   if(res.length >1 ){
  //     this.valueStr =  val.toFixed(res[1].length);
  //   }else {
  //     this.valueStr =  val.toString();
  //   }
  // }
}
